import * as React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { hasTranslationsLoaded, translationChanged } from 'app/infrastructure/translate/selectors';
import { getExternalUrlAdminAccess } from '../../get-access';
import { ListWrapperProps } from 'app/area/external-urls-administration/list/types-store';

export class ListWrapper
  extends React.PureComponent<ListWrapperProps> {

  public componentDidMount() {
    if (hasTranslationsLoaded(this.props.translation)) {
      this.initList();
    }
  }

  public componentDidUpdate(prevProps: ListWrapperProps) {
    if (translationChanged(this.props.translation, prevProps.translation)) {
      this.initList();
    }
  }

  private initList() {

    const { sharedState, displayError, translation } = this.props;

    if (!getExternalUrlAdminAccess(sharedState)) {
      displayError(translation.no_access_to_external_urls);
      navigate.toStartupView(true);
    }
  }

  public render() {

    if (!getExternalUrlAdminAccess(this.props.sharedState)) {
      return null;
    }

    return this.props.children;
  }
}
